export const IS_PREVIEW_QUERY_PARAM = "isPreview";
export const FROM_ONBOARDING_QUERY_PARAM = "fromOnboarding";
